import { FilesUpdateRequest } from '@kcftech/prometheus-client';
import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { NoValue } from 'components/no_value/NoValue';
import { sdClient } from 'contexts/SDKClientContext';

import { GetFileFromLibraryResult } from '../hooks/useFileFromLibrary';

const maxDescriptionLength = 256;

const validate = (val: string | undefined) => {
    if (val && val.length > maxDescriptionLength) {
        return `Description must be ${maxDescriptionLength} characters or less`;
    }
    return undefined;
};

export type FileDetailsDescriptionProps = Readonly<{
    file: GetFileFromLibraryResult;
    canEdit: boolean;
    refetchFile: () => void;
    refreshTable: () => void;
}>;

export function FileDetailsDescriptionEditor({
    file,
    canEdit,
    refetchFile,
    refreshTable,
}: FileDetailsDescriptionProps) {
    const onConfirm = async (updatedDescription: string | undefined) => {
        try {
            await sdClient
                .updateFile({
                    fileId: file.Id,
                    body: new FilesUpdateRequest({
                        DisplayName: file.Name,
                        ParentFolderId: file.ParentFolderId ?? '',
                        Description: updatedDescription,
                        GroupIds: file.GroupIds,
                    }),
                })
                .then(refetchFile)
                .then(refreshTable);
        } catch {
            return 'Unable to save description for File';
        }
        return undefined;
    };

    return (
        <TextInlineEditor
            valueClass="word-break"
            editorStyle={{ width: '50rem', marginTop: '-8px' }}
            isDisabled={!canEdit}
            value={file.Description}
            renderValue={(v) => v || <NoValue />}
            validate={validate}
            onConfirm={onConfirm}
        />
    );
}
